import { Component } from 'react';
import PropTypes from 'prop-types';
import { isDevelopmentEnv } from '@commons/consts';

const canUseDOM = () => {
  return (
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
};

export const ZendeskAPI = (...args) => {
  if (canUseDOM() && window.zE) {
    window.zE.apply(null, args);
  } else {
    console.warn('Zendesk is not initialized yet');
  }
};

export default class Zendesk extends Component {
  constructor(props) {
    super(props);
    this.insertScript = this.insertScript.bind(this);
    this.onScriptLoaded = this.onScriptLoaded.bind(this);
  }

  onScriptLoaded() {
    if (typeof this.props.onLoaded === 'function') {
      this.props.onLoaded();
    }
  }

  insertScript(zendeskKey, defer) {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
    script.defer = !!defer;
    script.addEventListener('load', this.onScriptLoaded);
    document.body.appendChild(script);
  }

  componentDidMount() {
    if (!canUseDOM() || isDevelopmentEnv()) return;

    if (!window.zE) {
      const { defer, zendeskKey, ...other } = this.props;
      this.insertScript(zendeskKey, defer);
      window.zESettings = other;
    }
  }

  componentWillUnmount() {
    if (!canUseDOM() || !window.zE) {
      return;
    }
    delete window.zE;
    delete window.zESettings;
    const script = document.getElementById('ze-snippet');
    if (script) {
      script.parentNode.removeChild(script);
    }
  }

  render() {
    return null;
  }
}

Zendesk.propTypes = {
  zendeskKey: PropTypes.string.isRequired,
  defer: PropTypes.bool,
  onLoaded: PropTypes.func,
};
